import * as ActionTypes from '../../constants/ActionTypes'
import store from "../../store";
import { toast  } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';

export const userResetOrders = () => ({
    type: ActionTypes.USER_ORDERS_RESET
});

export const getShopOrderlistProducts = (reqData, isShopDomain) => ({
    type: ActionTypes.USER_GET_SHOP_ORDERLIST_PRODUCTS_START,
    payload: reqData,
    isShopDomain: isShopDomain
});

export const getShopOrderlistProductsSuccess = (data) => {
    return {
        type: ActionTypes.USER_GET_SHOP_ORDERLIST_PRODUCTS_SUCCESS,
        payload: data,
    };
};

export const getShopOrderlistProductsFailure = (error) => ({
    type: ActionTypes.USER_GET_SHOP_ORDERLIST_PRODUCTS_FAILURE,
    payload: error,
});

export const getShopOrderDetail = (reqData, shopId, isShopDomain) => ({
    type: ActionTypes.USER_GET_SHOP_ORDER_DETAIL_START,
    payload: reqData,
    shopId: shopId,
    isShopDomain: isShopDomain
});

export const getShopOrderDetailSuccess = (data) => {
    return {
        type: ActionTypes.USER_GET_SHOP_ORDER_DETAIL_SUCCESS,
        payload: data,
    };
};
export const getShopOrderDetailFailure = (error) => ({
    type: ActionTypes.USER_GET_SHOP_ORDER_DETAIL_FAILURE,
    payload: error,
});


export const userUpdateOrderStatus = (reqData) => ({
    type: ActionTypes.USER_UPDATE_ORDER_STATUS_START,
    payload: reqData,
});

export const userUpdateOrderStatusSuccess = (data) => {
    return {
        type: ActionTypes.USER_UPDATE_ORDER_STATUS_SUCCESS,
        payload: data,
    };
};
export const userUpdateOrderStatusFailure = (error) => ({
    type: ActionTypes.USER_UPDATE_ORDER_STATUS_FAILURE,
    payload: error,
});
